import { ThemeProvider } from "@adsk/bim360-matrix-react-helpers/es/theme";
import { getBrowserLocale } from "../i18n/getBrowserLocale";
import { LocaleProvider } from "@adsk/bim360-matrix-react-helpers/es/locale";
import React from "react";

export const MatrixProvider: React.FC<{}> = ({ children }) => (
  <ThemeProvider theme={ThemeProvider.Themes.ALLOY}>
    <LocaleProvider locale={getBrowserLocale()}>{children}</LocaleProvider>
  </ThemeProvider>
);
